import { render, staticRenderFns } from "./NewsEditor.vue?vue&type=template&id=e997f2b2&scoped=true&"
import script from "./NewsEditor.vue?vue&type=script&lang=ts&"
export * from "./NewsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NewsEditor.vue?vue&type=style&index=0&id=e997f2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e997f2b2",
  null
  
)

export default component.exports